import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import CardAvatar from "components/Card/CardAvatar.js";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import PropTypes from "prop-types";

import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import Button from "components/CustomButtons/Button.js";
import Info from "@material-ui/icons/Info";

import styles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.js";
import stylesModal from "assets/jss/material-dashboard-pro-react/views/notificationsStyle.js";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";

import Close from "@material-ui/icons/Close";
import Slide from "@material-ui/core/Slide";

const stylesCenter = {
  center: {
    textAlign: "center",
  },
};

const stylesSize = {
  size: {
    fontSize: "large",
    color: "black",
    opacity: 1,
    textAlign: "left",
  },
};

const styleHeading = {
  heading: {
    fontWeight: "bold",
    textAlign: "center",
  },
};

const stylesCard = {
  cardList: {
    textAlign: "left",
  },
};

const stylesList = {
  list: {
    padding: 0,
    textAlign: "center",
    listStyle: "inside",
    fontSize: "large",
  },
};
const useStylesModal = makeStyles(stylesModal);

const useStylesBase = makeStyles(styles);

const useStylesCard = makeStyles(stylesCard);

const useStylesSize = makeStyles(stylesSize);
const useStylesCenter = makeStyles(stylesCenter);
const useStylesList = makeStyles(stylesList);
const useStylesHeading = makeStyles(styleHeading);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default function Leadership(props) {
  const classesBase = useStylesBase();
  const classesCard = useStylesCard();
  const classesModal = useStylesModal();
  const classesList = useStylesList();
  const classesSize = useStylesSize();
  const classesCenter = useStylesCenter();
  const classesHeading = useStylesHeading();

  const [infoModal, setInfoModal] = React.useState(false);
  const [institution, setInstitution] = React.useState("");
  const [about, setAbout] = React.useState("");
  const [image, setImage] = React.useState("");
  const [studies, setStudies] = React.useState([]);
  const [recentStudies, setRecentStudies] = React.useState([]);
  const [name, setName] = React.useState("");

  const classes = {
    ...classesBase,
    ...classesCard,
    ...classesModal,
    ...classesSize,

    ...classesList,
    ...classesCenter,
    ...classesHeading,
  };

  const handleSetInfoModal = (leaderName) => {
    clearData();

    const findNameIndex = ({ name }) => {
      return name == leaderName;
    };

    const emailIndex = props.members.findIndex(findNameIndex);

    const userData = props.members[emailIndex];

    const filteredStudies = props.studies.filter(function (study) {
      return (
        userData &&
        userData.verified_pubs &&
        userData.verified_pubs.includes(study.uid)
      );
    });

    if (userData) {
      userData.studies = filteredStudies.length;

      const studiesWithDate = filteredStudies.map((study) => {
        const withDate = { ...study, date: new Date(study.date) };

        return withDate;
      });

      const arrangedStudies = studiesWithDate.sort((a, b) => b.date - a.date);

      const recentStudies = arrangedStudies.slice(0, 5);

      userData.recentStudies = recentStudies;

      const userImage = props.images.filter((file) => {
        //const fileExt = file.split(".").pop();

        return file.includes("profile___" + userData.id + "___");
      });

      userData.userImage = userImage[0];

      addData(userData);
    }

    setInfoModal(true);
  };

  const addData = (userData) => {
    userData.name && setName(userData.name);
    userData.institution && setInstitution(userData.institution);
    userData.about && setAbout(userData.about);
    userData.studies && setStudies(userData.studies);
    userData.recentStudies && setRecentStudies(userData.recentStudies);
    userData.userImage && setImage(userData.userImage);
  };

  const clearData = () => {
    setName("");
    setInstitution("");
    setAbout("");
    setStudies([]);
    setImage("");
  };

  return (
    <div>
      <Dialog
        classes={{
          root: classes.center + " " + classes.modalRoot,
          paper: classes.modal,
        }}
        open={infoModal}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => setInfoModal(false)}
        aria-labelledby="notice-modal-slide-title"
        aria-describedby="notice-modal-slide-description"
      >
        <DialogTitle
          id="notice-modal-slide-title"
          disableTypography
          className={classes.modalHeader}
        >
          <Button
            justIcon
            className={classes.modalCloseButton}
            key="close"
            aria-label="Close"
            color="transparent"
            onClick={() => setInfoModal(false)}
          >
            <Close className={classes.modalClose} />
          </Button>
          <h4 className={classes.modalTitle}>{name}</h4>
        </DialogTitle>
        <DialogContent
          id="notice-modal-slide-description"
          className={classes.modalBody}
        >
          <div className={classes.modalBody}>
            {image && (
              <div>
                <br></br>
                <CardAvatar profile>
                  <img src={image} />
                </CardAvatar>
                <br></br>
              </div>
            )}
            <GridContainer>
              {institution && (
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <h4 className={classes.cardTitle}>
                      <b>Institution</b>
                    </h4>
                  </GridItem>

                  <GridItem xs={12} sm={12} md={12}>
                    <p>{institution}</p>
                  </GridItem>
                </GridContainer>
              )}

              {about && (
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <h4 className={classes.cardTitle}>
                      <b>About Me</b>
                    </h4>
                  </GridItem>

                  <GridItem xs={12} sm={12} md={12}>
                    <p>{about}</p>
                  </GridItem>
                </GridContainer>
              )}

              {studies > 0 && (
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <h4 className={classes.cardTitle}>
                      <b>Number of PALISI Publications</b>
                    </h4>
                  </GridItem>

                  <GridItem xs={12} sm={12} md={12}>
                    {studies}
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}>
                    <h4 className={classes.cardTitle}>
                      <b>Latest PALISI Publications</b>
                    </h4>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}>
                    {recentStudies &&
                      recentStudies.map((study) => (
                        <li key={study}>
                          <a
                            href={
                              "https://pubmed.ncbi.nlm.nih.gov/" + study.uid
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {study.title}
                          </a>
                        </li>
                      ))}
                  </GridItem>
                </GridContainer>
              )}
            </GridContainer>
          </div>
        </DialogContent>
        <DialogActions
          className={classes.modalFooter + " " + classes.modalFooterCenter}
        >
          <Button
            onClick={() => {
              clearData();
              setInfoModal(false);
            }}
            color="rose"
            round
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card profile>
            <CardBody profile>
              <div className={classes.size}>
                <h3 className={classes.heading}>Leadership</h3>
                <div>
                  <br></br>
                  <h4 className={classes.heading}>
                    Executive Steering Committee
                  </h4>

                  <ul className={classes.list}>
                    <li>
                      Anoop Bhalla (chair)
                      <Button
                        justIcon
                        round
                        simple
                        onClick={() => {
                          handleSetInfoModal("Anoopindar Bhalla");
                        }}
                        color="info"
                        className="remove"
                      >
                        <Info />
                      </Button>
                    </li>
                    <li>
                      Guillaume Emeriaud (chair-elect)
                      <Button
                        justIcon
                        round
                        simple
                        onClick={() => {
                          handleSetInfoModal("Guillaume Emeriaud");
                        }}
                        color="info"
                        className="remove"
                      >
                        <Info />
                      </Button>
                    </li>
                    <li>
                      Robinder Khemani (past chair)
                      <Button
                        justIcon
                        round
                        simple
                        onClick={() => {
                          handleSetInfoModal("Robinder Khemani");
                        }}
                        color="info"
                        className="remove"
                      >
                        <Info />
                      </Button>
                    </li>

                    <li>
                      Jocelyn Grunwell
                      <Button
                        justIcon
                        round
                        simple
                        onClick={() => {
                          handleSetInfoModal("Jocelyn Grunwell");
                        }}
                        color="info"
                        className="remove"
                      >
                        <Info />
                      </Button>
                    </li>

                    <li>
                      Samer Abu-Sultaneh
                      <Button
                        justIcon
                        round
                        simple
                        onClick={() => {
                          handleSetInfoModal(
                            "Samer Abu-Sultaneh, MD, FFAP, FCCM"
                          );
                        }}
                        color="info"
                        className="remove"
                      >
                        <Info />
                      </Button>
                    </li>

                    <li>
                      Philippe Jouvet
                      <Button
                        justIcon
                        round
                        simple
                        onClick={() => {
                          handleSetInfoModal("Philippe Jouvet MD PhD");
                        }}
                        color="info"
                        className="remove"
                      >
                        <Info />
                      </Button>
                    </li>
                  </ul>
                  <br></br>
                  <h4 className={classes.heading}>Advisory Committee</h4>

                  <ul className={classes.list}>
                    <li>
                      Neal Thomas{" "}
                      <Button
                        justIcon
                        round
                        simple
                        onClick={() => {
                          handleSetInfoModal("Neal Thomas");
                        }}
                        color="info"
                        className="remove"
                      >
                        <Info />
                      </Button>
                    </li>
                    <li>
                      Christopher Newth{" "}
                      <Button
                        justIcon
                        round
                        simple
                        onClick={() => {
                          handleSetInfoModal("Christopher (Kit) Newth");
                        }}
                        color="info"
                        className="remove"
                      >
                        <Info />
                      </Button>
                    </li>
                  </ul>
                </div>
              </div>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}

Leadership.propTypes = {
  members: PropTypes.array,
  studies: PropTypes.array,
  images: PropTypes.array,
};
